import Controller from 'controllers/controller';
import LazyLoad from 'tools/lazy-load';
import Binder from 'tools/binder';
import Helpers from 'tools/helpers';

class LazyLoadController extends Controller {
    constructor(app) {
        super(app);

        this.binder = new Binder(this);
        
        this.lazyLoad = LazyLoad;
        this.lazyLoad.init();
        
        this.attachEvents();
    }
    
    attachEvents() {
        this.app.loaderController.on('page-loaded', Helpers.throttledFunction(250, this.binder.bind('onPageLoaded')))
    }
    
    onPageLoaded() {
        this.lazyLoad.domHasChanged();
        this.lazyLoad.load('on-load');
    }
}

export default LazyLoadController;